export function groupByAsSortedArray<U>(
  items: U[],
  grouper: (i: U) => string | number | symbol,
  sorter: (a: string, b: string) => number,
  _reverse: boolean = false,
): U[][] {
  const groups = groupBy(items, grouper);
  const array = Object.entries(groups)
    .sort(([a], [b]) => sorter(a, b))
    .map(([, items]) => items);

  return array;
}

export function groupBy<U>(items: U[], by: (i: U) => string | number | symbol): Record<string | number | symbol, U[]> {
  const init = {} as Record<string | number | symbol, U[]>;
  return items.reduce((acc, item) => group(by, acc, item), init);
}

export function group<U>(
  groupBy: (i: U) => string | number | symbol,
  acc: Record<string | number | symbol, U[]> | undefined,
  item: U,
): Record<string | number | symbol, U[]> {
  if (acc === undefined) acc = {} as Record<string, U[]>;

  const keyValue = groupBy(item);
  if (acc[keyValue] === undefined) acc[keyValue] = [];
  acc[keyValue].push(item);
  return acc;
}
